<template>
    <div>
        <b-button class="align-baseline" title="Delete" variant="default" @click="onConfirmDeleteSecurityKey">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteSecurityKeyModalId"
            ok-title="Delete"
            title="Delete Security Key"
            @ok="onDeleteSecurityKey"
        >
            Are you sure you want to delete this Security Key? Two Step Authentication will be disabled if no keys remain.
        </modal>
    </div>
</template>

<script>
import Modal from '../generic/modal/modal.vue';

export default {
    components: { Modal },
    data() {
        return {
            securityKey: null,
            deleteSecurityKeyModalId: 'delete-security-key-modal-id',
        };
    },
    created() {
        this.securityKey = this.params.data;
    },
    methods: {
        onConfirmDeleteSecurityKey() {
            this.$bvModal.show(this.deleteSecurityKeyModalId);
        },
        onDeleteSecurityKey() {
            this.params.onDeleteSecurityKey();
        },        

    },
};
</script>
